import { render, staticRenderFns } from "./InquireUserModal.vue?vue&type=template&id=12a3bec1"
import script from "./InquireUserModal.vue?vue&type=script&lang=js"
export * from "./InquireUserModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports